import SimpleBar from 'simplebar';
import requestAnimationFrame from '@/utils/request-animation-frame';
import uniqueId from 'uniqid';

import 'simplebar/dist/simplebar.css';

const SELECTOR = 'vjs-scrollbar';

const cloneEl = el => {
    const clone = el.cloneNode(true);
    clone.setAttribute('style', 'display:block;visibility:visible;position:absolute;top:-9999px;left:-9999px;overflow:hidden');
    return clone;
};

const trackScrollable = (el, id) => {
    const clone = cloneEl(el);
    clone.id = id;

    const toggleScrollable = el => {
        if(!document.getElementById(id)) {
            document.body.appendChild(clone);
        }

        if(clone.clientHeight < clone.scrollHeight) {
            el.classList.add('-scrollable');
        } else {
            el.classList.remove('-scrollable');
        }

        clone.remove();
    };

    toggleScrollable(el);

    window.addEventListener('resize', () => requestAnimationFrame(toggleScrollable(el)));
};

let instanceArr = [];

export function destroy() {
    instanceArr.forEach(id => {
        document.getElementById(id)?.remove();
    });

    instanceArr.splice(0, instanceArr.length);
}

export default function() {
    const elements = document.querySelectorAll(`[${SELECTOR}]`);
    elements?.forEach((el, i) => {
        const id = `__aha-scrollable_${uniqueId()}_`;
        instanceArr[i] = id;
        trackScrollable(el, id);

        new SimpleBar(el, { autoHide: false });
    });
}
